
import { ILockscreenNfcBadge, LockScreenService } from "@/services/lockscreen-service";
import {ScannerListener} from "@/utils/scanner";
import { UnifiedNfcReader } from "@/utils/unified-nfc-reader";
import Vue from "vue";
import AppNfcPinCodeInput from "./NfcPinCodeInput.vue";

export default Vue.extend({
	data(){
		return {
			label: "",
			uid: "",
			isSaving: false,
			showCardExistsError: false,
			pinCode: "",
			pinCodeBlured: false
		};
	},
	props: {
		existingBadges: {
			type: Array as ()=>ILockscreenNfcBadge[],
			required: true
		}
	},
	computed: {
		isLabelUnique():boolean {
			for (let badge of this.existingBadges) {
				if (badge.Label == this.label.trim()) {
					return false;
				}
			}
			return true;
		},
		valid():boolean {
			if (!this.label) return false;
			if (!this.uid) return false;
			if (!this.isLabelUnique) return false;
			if (!this.pinCodeIsValid) return false;
			if (this.showCardExistsError) return false;
			return true;
		},
		pinCodeIsValid():boolean{
			return LockScreenService.isPinCodeValid(this.pinCode);
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (!this.valid) return;
			if (this.isSaving) return;
			this.isSaving = true;
			try{
				await LockScreenService.addNfcBadge(this.label, this.uid, this.pinCode);
				this.$emit("refresh");
				this.close();
			}catch(err){

			}
			this.isSaving = false;
		},
		async onScan(uid:string){
			console.log("On nfc scan", uid);
			this.uid = "";
			this.showCardExistsError = false;
			let result = await LockScreenService.badgeExists(uid);
			if (result){
				this.showCardExistsError = true;
			}else{
				this.uid = uid;
			}
		},
	},
	created(){
		UnifiedNfcReader.on(UnifiedNfcReader.READER_SCANNED_EVENT, this.onScan);
		ScannerListener.onInput(this.onScan);
	},
	destroyed(){
		UnifiedNfcReader.off(UnifiedNfcReader.READER_SCANNED_EVENT, this.onScan);
		ScannerListener.offInput(this.onScan);
	},
	components: {
		AppNfcPinCodeInput
	},
	i18nEx: {
		componentPrefix: "components.LockScreen"
	}
});
